export enum KpiValueType {
    time = 'time',
    value = 'value',
    percentage = 'percentage'
}
